export default {
  'error-code.ARE-0000': 'Bạn không có quyền truy cập thông tin này',
  'error-code.ARE-0002': 'Mã xác nhận không chính xác',
  'error-code.ARE-0003': 'Mã xác nhận đã hết hạn',
  'error-code.ARE-0004':
    'Vượt quá số lần gửi lại mã xác nhận cho phép. Vui lòng thử lại sau 30 phút nữa!',
  'error-code.ARE-0008': 'Số điện thoại sai định dạng',
};
